import { TaskStatuses } from '../Task';
import switchStatus from './switchStatus';
import { actions } from '../store';

export default switchStatus(TaskStatuses.COMPLETED, actions.setTaskAsCompleted);
